export default __webpack_public_path__ + "static/il-5bc6f6922fe3176494573527522ade4e.svg";